export default __webpack_public_path__ + "assets/6cbaf8a891d15447c89bb5fc872c2082.svg";